// Simple time utilities (HH:mm strings)

export function hmToMinutes(hm: string): number {
  const [h, m] = hm.split(':').map((x) => parseInt(x, 10))
  return h * 60 + m
}

export function minutesToHm(mins: number): string {
  const h = Math.floor(mins / 60)
  const m = mins % 60
  const pad = (n: number) => (n < 10 ? `0${n}` : String(n))
  return `${pad(h)}:${pad(m)}`
}

export function generateSlots(
  startHm: string,
  endHm: string,
  durationMin: number,
): Array<string> {
  const out: Array<string> = []
  let t = hmToMinutes(startHm)
  const end = hmToMinutes(endHm)
  while (t <= end) {
    out.push(minutesToHm(t))
    t += durationMin
  }
  return out
}

export function roundUpToSlot(
  nowHm: string,
  startHm: string,
  durationMin: number,
): string {
  const n = hmToMinutes(nowHm)
  const s = hmToMinutes(startHm)
  if (n <= s) return startHm
  const delta = n - s
  const k = Math.ceil(delta / durationMin)
  return minutesToHm(s + k * durationMin)
}

export function compareHm(a: string, b: string): number {
  return hmToMinutes(a) - hmToMinutes(b)
}
